import { LoadingContainer, LoadingSpinner } from './styles';

export function Loading() {
  return (
    <LoadingContainer>
      <LoadingSpinner />
    </LoadingContainer>
  );
}
